import pathOr from 'ramda/src/pathOr'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import always from 'ramda/src/always'

export default (state, { moduleId }) => {
	const linkSelector = pathOr(always(undefined), [moduleId, 'link'], moduleDescriptions)
	return linkSelector(state)
}
